import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/comics';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mx-4 md:mx-8 mb-6 md:mb-8 mt-16 md:mt-24">
      <div className="bg-foreground-950 rounded-2xl px-6 md:px-14 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
              订阅更新通知
            </h3>
            <p className="text-white/50 text-sm leading-relaxed mb-6 max-w-md">
              第一时间获取最新漫画更新、热门作品推荐和独家活动信息。不错过任何精彩内容。
            </p>
            <div className="flex flex-col sm:flex-row gap-3 max-w-md">
              <input
                type="email"
                placeholder="输入您的邮箱地址"
                className="flex-1 bg-white/10 border border-white/20 rounded-full px-5 py-3 text-sm text-white placeholder:text-white/40 outline-none focus:border-accent-400 transition-colors"
              />
              <button className="px-6 py-3 bg-white text-foreground-950 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-accent-400 hover:text-white transition-all duration-300">
                订阅 <i className="ri-arrow-right-line ml-1"></i>
              </button>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-white text-sm font-semibold mb-5">快速链接</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-white/50 text-sm hover:text-accent-400 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/rexue" className="text-white/50 text-sm hover:text-accent-400 transition-colors whitespace-nowrap">热门分类</Link>
              <Link to="/about" className="text-white/50 text-sm hover:text-accent-400 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-white text-sm font-semibold mb-5">热门漫画</h4>
            <div className="flex flex-col gap-3">
              <Link to="/comic/mitao-shaonian" className="text-white/50 text-sm hover:text-accent-400 transition-colors whitespace-nowrap">蜜桃少年</Link>
              <Link to="/comic/jiansheng-chuanshuo" className="text-white/50 text-sm hover:text-accent-400 transition-colors whitespace-nowrap">剑圣传说</Link>
              <Link to="/comic/xingkong-zhi-xia" className="text-white/50 text-sm hover:text-accent-400 transition-colors whitespace-nowrap">星空之下</Link>
              <Link to="/comic/mofa-xueyuan" className="text-white/50 text-sm hover:text-accent-400 transition-colors whitespace-nowrap">魔法学院</Link>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-white text-sm font-semibold mb-5">联系我们</h4>
            <div className="flex flex-col gap-3">
              <p className="text-white/50 text-sm">{siteInfo.phone}</p>
              <p className="text-white/50 text-sm">{siteInfo.email}</p>
              <h4 className="text-white text-sm font-semibold mt-4 mb-2">公司地址</h4>
              <p className="text-white/50 text-sm leading-relaxed">{siteInfo.address}</p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <a href="#" className="text-white/40 text-sm hover:text-accent-400 transition-colors whitespace-nowrap" rel="nofollow">微博</a>
            <a href="#" className="text-white/40 text-sm hover:text-accent-400 transition-colors whitespace-nowrap" rel="nofollow">微信公众号</a>
            <a href="#" className="text-white/40 text-sm hover:text-accent-400 transition-colors whitespace-nowrap" rel="nofollow">Bilibili</a>
          </div>
          <p className="text-white/30 text-sm">
            &copy; {currentYear} {siteInfo.name} 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-white/40 text-sm hover:text-accent-400 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-white/40 text-sm hover:text-accent-400 transition-colors whitespace-nowrap" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}